import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  state: {
    workPlace: null,
    workPlaces: [],
    unitWorkPlace: [],
    workPlaceServiceCategories: [],
    isLoadingWorkPlaceServiceCategories: false,
  },
  getters: getters,
  mutations: mutations,
  actions: actions,
}
